import { ReactNode, useMemo } from 'react';
import styles from './ApplicationDataBaseField.module.css';
import { Icon } from '@blueprintjs/core';
import { ApplicationDataFieldCommonProps } from './types';
import { useApplicationDataFieldContext } from './useApplicationDataFieldContext';
import { useApplicationDataStore } from '../../../store/applicationDataStore';

interface ApplicationDataBaseFieldProps
  extends ApplicationDataFieldCommonProps {
  valueElement: ReactNode;
  inputElement?: ReactNode;
  errorMessage?: string;
}

export const ApplicationDataBaseField: React.FC<
  ApplicationDataBaseFieldProps
> = ({
  label,
  errorMessage,
  horizontal,
  fullWidth,
  inputElement,
  valueElement,
  isVisible = true,
  isEditable = true,
  applicationID,
}) => {
  const { isEditing } = useApplicationDataStore(applicationID);
  const ctx = useApplicationDataFieldContext(applicationID);

  const visible = useMemo(
    () =>
      typeof isVisible === 'function' ? isVisible(ctx) : Boolean(isVisible),
    [ctx, isVisible],
  );

  const editable = useMemo(
    () =>
      typeof isEditable === 'function' ? isEditable(ctx) : Boolean(isEditable),
    [ctx, isEditable],
  );

  if (!visible) return null;

  return (
    <div className={styles.rootContainer}>
      <div
        className={`${
          !fullWidth ? styles.infoContainer : styles.infoContainerFull
        } ${horizontal ? styles.horizontal : ''}`}
      >
        {label ? <div className={styles.label}>{label}:</div> : null}
        <div className={styles.value}>
          {isEditing && editable && inputElement ? inputElement : valueElement}
        </div>
      </div>
      {errorMessage ? (
        <div className={styles.errorContainer}>
          <Icon icon="warning-sign" size={12} />
          <p>{errorMessage}</p>
        </div>
      ) : null}
    </div>
  );
};
